var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "article-details__actions ci-content-padding pb-0 d-flex flex-wrap",
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-grow-1 align-items-center flex-wrap" },
        [
          !_vm.content.is_short_news && _vm.content.content_type !== "Video"
            ? _c(
                "div",
                {
                  staticClass:
                    "article-details__actions-item reading-time mr-3 mr-md-5 d-flex align-items-center",
                },
                [
                  _c("span", { staticClass: "mdi mdi-timer-outline mr-1" }),
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("ui.shared.global.minutes.abbr.other", {
                          count:
                            _vm.content.reading_minutes <= 1
                              ? 1
                              : _vm.content.reading_minutes,
                        })
                      ),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.content.publication_date
            ? _c(
                "div",
                {
                  staticClass:
                    "article-details__actions-item publishing-date mr-3 mr-md-5 d-flex align-items-center",
                },
                [
                  _c("span", { staticClass: "mdi mdi-calendar mr-1" }),
                  _c("span", {
                    directives: [
                      {
                        name: "ci-format-date",
                        rawName: "v-ci-format-date",
                        value: _vm.content.publication_date,
                        expression: "content.publication_date",
                      },
                    ],
                  }),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "article-details__actions-item sharing" },
            [
              _c("ci-share", {
                attrs: {
                  "tracking-target": _vm.shareTrackingTarget,
                  url: _vm.content.sharing_url,
                  title: _vm.content.title,
                  description: _vm.content.teaser,
                  dropdown: true,
                  "prevent-toggle": false,
                  type: "article",
                  networks: _vm.sharingNetworks,
                  label: _vm.$t("social_share"),
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "article-details__actions-item watching mr-3 mr-md-5",
            },
            [
              _c("ci-bookmark", {
                attrs: {
                  item: _vm.content,
                  type: "contents",
                  "button-size": "sm",
                  "with-label": true,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }